// API client + auth context
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL?.replace(/\/$/, "");
export const API = process.env.NODE_ENV === "development" && BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

const TOKEN_KEY = "gma_token";
const USER_KEY = "gma_user";

export const auth = {
  getToken() { return localStorage.getItem(TOKEN_KEY); },
  getUser() {
    const u = localStorage.getItem(USER_KEY);
    return u ? JSON.parse(u) : null;
  },
  setSession(token, user) {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  },
  clear() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  },
};

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = auth.getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      auth.clear();
      if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/register")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatEUR(n) {
  if (n == null) return "-";
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);
}
export function formatDate(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  return d.toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
}
export function daysUntil(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  return Math.ceil((d - new Date()) / (1000 * 60 * 60 * 24));
}
